/* eslint-disable no-duplicate-case */
import { Button } from "@shopify/polaris";
import React, { useState } from "react";
import emoji1 from "../../assets/emoji/1.png";
import emoji2 from "../../assets/emoji/2.png";
import emoji3 from "../../assets/emoji/3.png";
import emoji4 from "../../assets/emoji/4.png";
import emoji5 from "../../assets/emoji/5.png";
import "../../css/dispute-template.css";
import { useSelector } from "react-redux";
import { Col, Row } from "reactstrap";
import disputeImg from "../../assets/dispute_template/img.svg";
import RDBanner from "../../assets/dispute_template/RDBanner.png";
import lastest from "../../assets/dispute_template/lastest.svg";

// import "swiper/css";
// import "swiper/css/navigation";
// import "swiper/css/pagination";
// import "swiper/css/scrollbar";
import { Swiper, SwiperSlide } from "swiper/react";
import  { Autoplay, Navigation, Pagination } from "swiper";
import "swiper/swiper.min.css";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";

import BFCM_ebook from "../../assets/feature/BFCM_ebook.png";
import YEARLY_BANNER from "../../assets/yearly/yearly-banner.png";
import YearlyBannerOnly from "../feature/yearly/YearlyBannerOnly";
import config from "../../config/config";
import YearlyHaftEnhance from "../feature/yearly/YearlyHaftEnhance";

const DisputeTemplate = (props) => {
	const [swiperIndex,setSwiperIndex] = useState(0)
	const [submitStatus, setsubmitStatus] = useState(false);
	const dataSettings = useSelector((state) => state.dataSettings);
	const [suggest, setsuggest] = useState("");
	const [star, setstar] = useState(0);
	const [feedback, setfeedback] = useState([]);
	const hasStorage = "sessionStorage" in window && window.sessionStorage;
	const listIcon = [
		{ id: 1, src: emoji1 },
		{ id: 2, src: emoji2 },
		{ id: 3, src: emoji3 },
		{ id: 4, src: emoji4 },
		{ id: 5, src: emoji5 },
	];
	const listFeedback = [
		{ id: 1, content: "Ease of use" },
		{ id: 2, content: "Speed of service" },
		{ id: 3, content: "Interface" },
		{ id: 4, content: "Customer Support" },
		{ id: 5, content: "Price" },
		{ id: 6, content: "Other features" },
	];
	const chooseFeedback = (content) => {
		let newFeedback = [...feedback];
		if (!newFeedback.includes(content)) {
			newFeedback.push(content);
		} else {
			let index = newFeedback.findIndex((x) => x === content);
			newFeedback.splice(index, 1);
		}
		setfeedback(newFeedback);
		setsubmitStatus(false);
	};
	const getdisputeTemplate = () => {
		const crisp = window.$crisp;
		const sendText = "I want to get Dispute template!";
		if (crisp) {
			crisp.push(["do", "chat:open"]);
			crisp.push(["do", "message:send", ["text", sendText]]);
		}
	};

	const disputeTemplateMarkup = (
		<div className="dispute-template-card">
			<Row>
				<Col xs="12" sm="12" md="12" lg="6">
					<div className="img-des">
						<img src={disputeImg} />
					</div>
				</Col>
				<Col xs="12" sm="12" md="12" lg="6">
					<div className="lastest">
						{/* <img
                            src={lastest}
                            style={{ width: "100%" }}
                        /> */}
					</div>
					<div className="title">
						We are giving you a list of <br />{" "}
						<b>DISPUTE TEMPLATES</b>
					</div>{" "}
					<div className="description mt-3">
						They are the emails which help you communicate with your
						customers or <strong>PayPal</strong> to win when a
						dispute has been raised
					</div>
					<Button
						onClick={() => getdisputeTemplate()}
						className="mt-4"
					>
						Click to get templates
						{/* <img  src={disputeButton} /> */}
					</Button>
				</Col>
			</Row>
		</div>
	);

	const returnDriveMarkup = (
		<div>
			<div
				onClick={() => window.open('https://apps.shopify.com/omega-returns-drive?locale=fr&surface_detail=banner&surface_type=ST','_blank')}
				style={{ cursor: "pointer" }}
			>
				<img src={RDBanner} style={{ width: "100%" }} />
			</div>
		</div>
	);

	const YearlyMMarkup = (
    <div className="yearly-got-gift-dashboard" style={{height: "100%"}}>
      <YearlyHaftEnhance note="in_dashboard" />
    </div>
  );

	let carouselConfig = [ disputeTemplateMarkup,returnDriveMarkup];
	// if (
	// 	config.platform !== "WOO_COMMERCE" &&
	// 	dataSettings.plan !== "unlimited" &&
	// 	dataSettings.plan !== "pro_plus"
	// ) {
	// 	carouselConfig = [YearlyMMarkup, disputeTemplateMarkup];
	// }
		console.log(swiperIndex);
	const carouselMarkup = (
		<div style={{ width: "100%" }}>
			<Swiper
				// install Swiper modules
				className={`swiper-index${swiperIndex}`}
				modules={[Pagination, Autoplay]}
				spaceBetween={50}
				slidesPerView={1}
				autoplay={{
					delay: 5000,
					disableOnInteraction: false,
				}}
				// navigation
				pagination={{ clickable: true }}
				onSlideChange={(swiper) => setSwiperIndex(swiper.realIndex)}
				// scrollbar={{ draggable: true }}
				// onSwiper={(swiper) => console.log(swiper)}
				// onSlideChange={() => console.log("slide change")}
			>
				{carouselConfig.map((item, index) => (
					<SwiperSlide key={index}>{item}</SwiperSlide>
				))}
			</Swiper>
		</div>
	);

	return <>{carouselMarkup}</>;
};

export default DisputeTemplate;
